var simpleApp = angular.module('simpleApp', ['ngRoute','ngAnimate','simpleService','simpleRoutes','simpleDirective', 'simpleController', 'angularUtils.directives.dirDisqus', 'ngDialog']);

// set up configuration variables
simpleApp.run(function($rootScope, $http, $location){

	$rootScope.api = WPAPI.api_url;
	$rootScope.nonce = WPAPI.api_nonce;          // this is especially important to get for API calls that require authentication
	$rootScope.dir = WPAPI.template_url;

    $http.defaults.headers.common = { 'X-WP-Nonce' : $rootScope.nonce }
    $http({
		method: 'GET',
		url: '/wp-json/simple/category/'
	}).then(function successCallback(response) {
		$rootScope.badgeColors = response.data.colors;
		$rootScope.termList = response.data.terms;
	}, function errorCallback(response) {
	// called asynchronously if an error occurs
	// or server returns response with an error status.
	});
	$rootScope.submitSearch = function(search) {
		if(search.length < 1){
			$location.search('s', null);
		}else{
			$location.path('/');
			$location.search('s', search);
		}
		$('.search-form-wrap').removeClass('active');
        $('.search-form-wrap input').blur();
  	};
});

simpleApp.filter("sanitize", ['$sce', function($sce) {
  return function(htmlCode){
    return $sce.trustAsHtml(htmlCode);
  }
}]);